import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';

import { makeStyles } from '@material-ui/core/styles';

import AppBar from './AppBar';
import Banner from './Banner';
import WASMContainer from './WASMContainer';

import './App.css';
import { ClassNames } from '@emotion/react';

const useStyles = makeStyles({
  wasmWrapper: {
    background:"#eee",
    padding:"50px 0 50px 0",
    minHeight: "50vh"
  },
  wasmContainer: {
    background:"#FFF",
    border:"1px solid #ccc",
    borderRadius:10,
  },
  footer:{
    background:"#666666",
    color:"#FFF",
    paddingTop:15
  },
  root:{
    background:"#666666",
    minHeight:"100vh"
  },
  featureWrapper:{
    background:"#FFF",
    padding:"40px 0"
  },
  feature:{
    padding:"15px"
  },
  featureBody:{
    marginTop:'30px'
  }

});

function App() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
        <AppBar />
        <div className={classes.wasmWrapper}>
          <Container maxWidth="md">
            <Grid spacing={2} className={classes.wasmContainer} container direction="column" >
              <Grid item>
                <Typography align="center" variant="h3"> Extract Audio from Video </Typography>
                <Typography className={classes.featureBody} align="center" variant="body1">
                  Convert your video files into audio, all directly within your browser.<br/>
                  Select a file from your computer to get started.
                </Typography>
                <WASMContainer operation="extract-audio" />
              </Grid>
            </Grid>
          </Container>
        </div>
        {false && <div className={classes.featureWrapper}>
          <Container maxWidth="md">
            <Grid spacing={2} container>
              <Feature title="Feature 1" body="Lorem ipsum dolor sit amet"/>
              <Feature title="Feature 2" body="Lorem ipsum dolor sit amet"/>
              <Feature title="Feature 3" body="Lorem ipsum dolor sit amet"/>
            </Grid>
          </Container>
        </div>}
        <Footer />
    </div>
  );
}

type FeatureProps = {
  title: string;
  body: string;
}
function Feature(props:FeatureProps){
  const classes = useStyles();
  return (
    <Grid item md={4} xs={12}>
      <Card variant="outlined" className={classes.feature}>
        <Typography align="center" variant="h5">{props.title}</Typography>
        <Typography variant="body1">{props.body}</Typography>
      </Card>
    </Grid>
  )
}

function Footer(){
  const classes = useStyles();
  return (
    <Paper elevation={0} className={classes.footer}>
      <Container maxWidth="md">
      <Grid item xs={12}>
        <Typography align="center" variant="body1">Copyright © 2022 Audiogram. All rights reserved.</Typography>
      </Grid>
        { false && <Grid container>
          <Grid item xs={12} md={2}>
            Link 1
          </Grid>
          <Grid item xs={12} md={2}>
            Link 2
          </Grid>
          <Grid item xs={12} md={2}>
            Link 3
          </Grid>
          <Grid item xs={12} md={2}>
            Link 4
          </Grid>
          <Grid item xs={12} md={2}>
            Link 5
          </Grid>
          <Grid item xs={12} md={2}>
            Link 6
          </Grid>
        </Grid> }
      </Container>
    </Paper>
  )
}

export default App;
